import * as React from "react";

import { Image } from "components";
import { Div } from "containers/Responsive";
import { appendToClassName } from "lib/helpers";

export interface ModalProps {
  id?: string;
  active: boolean;
  closeModal?: () => void;
  back?: [string, () => void];
  onOpenModal?: () => void;
  children: React.ReactNode;
  className?: string;
}

function CloseModalButton(props: {
  back?: [string, () => void];
  onCloseModal: () => void;
}) {
  let style = {};
  if (!props.back) {
    style = { width: "100%", textAlign: "right" };
  } else {
    style = {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    };
  }
  return (
    <div style={style}>
      {props.back && (
        <span className="modal-back-button" onClick={props.back[1]}>
          <i
            className="fa fa-angle-left"
            style={{ fontSize: "22px", marginRight: "10px" }}
            aria-hidden="true"
          />
          {props.back[0]}
        </span>
      )}
      <span
        id="button-close-modal"
        className="close-modal-button"
        onClick={props.onCloseModal}
      >
        <Image alt="Close Modal" name="orderbook/close_modal_icon.svg" />
      </span>
    </div>
  );
}

export class ResponsiveModal extends React.Component<ModalProps> {
  public componentDidUpdate(prevProps: ModalProps) {
    if (!prevProps.active && this.props.active) {
      if (this.props.onOpenModal) {
        this.props.onOpenModal();
      }
    }
  }

  public render() {
    const { active, closeModal, children, back, className, id } = this.props;

    const containerClass = appendToClassName(
      active ? "modal-on" : "modal-off",
      appendToClassName("modal-container", className),
    );

    return (
      <Div className={containerClass} id={id}>
        <div className="modal-content">
          {closeModal && (
            <CloseModalButton back={back} onCloseModal={closeModal} />
          )}
          {active && children}
        </div>
      </Div>
    );
  }
}
